<template>
   <div class="row">
      <!--<div v-if="menu" class="col-xl-3 col-lg-4 col-md-12 menu">
         {{> menu menu}}
      </div>-->
   <!--<div :class="( menu ? 'col-xl-9 col-lg-8 ': '' )+'col-md-12'">-->
   <div class="col-md-12">
      <div class="page-info">
         <div class="title">{{__('label:error 404')}}</div>
         <div class="subtitle" v-html="__('info:error 404')" />
      </div>
      <NavButton type="primary" label="Start Fee Calculation" @goTo="$router.push({name:'user-info'})" />
   </div>
</div>
</template>

<script>
   import __ from 'common/hbs-helpers/__'
   export default {
      mounted: function() {
         //this.$store.dispatch('global/updateBreadcrumbs')
      },
      methods: {
         __
      }
   }
</script>
